export const INTERVENTION_CONTACT_TYPE_PRE_INTERVENTION_VALIDATOR = 'pre_intervention_validator';

export const INTERVENTION_CONTACT_TYPE_PRE_INTERVENTION_READER = 'pre_intervention_reader';

export const INTERVENTION_CONTACT_TYPE_RESPONSIBLE = 'responsible';
